
import React, { useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useMounted from '../../../hooks/useMounted';
import { IsModemAccess } from '../../../helpers/Helper';


import SimpleReactValidator from 'simple-react-validator';
import { post } from '../../../helpers/api_helper';
import { POST_GET_CHEQUE_FORMAT_DETAIL, POST_ADD_EDIT_CHEQUE_FORMAT } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import Loader from '../../../components/Loader';

const Setting = (props) => {
    const navigate = useNavigate();

    const [isLoader, setLoader] = useState(0);

    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [BankList, SetBankList] = useState([]);
    const [form_inputs, setInputs] = useState({ 
        formatId: 0, 
        bankId: '', 
        formatName: '', 
        image: '', 
        chequeDateStartingLocationFromLeft : '' ,
        chequeDateStartingLocationFromTop : '' ,
        chequeDateStyleOfDate : '' ,
        chequeDateDistanceBetweenCharacters : '' ,
        payeeNameStartingLocationFromLeft : '' ,
        payeeNameStartingLocationFromTop : '' ,
        payeeNameWidth : '' ,
        amountWordsStartingLocation1LineFromLeft : '' ,
        amountWordsStartingLocation1LineFromTop : '' ,
        amountWordsStartingLocation2LineFromLeft : '' ,
        amountWordsStartingLocation2LineFromTop : '' ,
        amountWordsWidth : '' ,
        amountFiguresStartingLocationFromLeft : '' ,
        amountFiguresStartingLocationFromTop : '' ,
        amountFiguresWidth : '' ,
    });
    const [, forceUpdate] = useState();

    const { id } = useParams()

    useMounted(() => {
        async function get_detaile() {
            var res_data = await post(POST_GET_CHEQUE_FORMAT_DETAIL, { 'formatId': id });
            if (res_data.status) {
                SetBankList(res_data.data.bankList)
                if (id) {
                    if (!IsModemAccess('cheque_format', 'edit')) {
                        toast.error('Does not permission this module');
                        navigate("/admin/dashboard");
                    }
                    if (res_data.data.detail) {
                        setInputs(res_data.data.detail);
                    }
                } else {
                    if (!IsModemAccess('cheque_format', 'add')) {
                        toast.error('Does not permission this module');
                        navigate("/admin/dashboard");
                    }
                }
            } else {
                toast.error(res_data.message);
                navigate("/admin/dashboard");
            }
            setLoader(1)
        }

        get_detaile();
    }, [])

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_EDIT_CHEQUE_FORMAT, form_inputs, {});
            if (res_data.status) {
                toast(res_data.message);
                navigate("/admin/cheque-formates");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        if (event.target.name === 'image') {
            var file_extension = event.target.files[0].name.split('.').pop();
            var file_size = event.target.files[0].size;
                file_size = (file_size / 1024 / 1024).toFixed(1);

            var extension = ['png', 'jpg', 'jpeg'];
            if (!extension.includes(file_extension.toLowerCase())) {
                toast.error('Alludu only file png, jpg and jpeg.');
                event.target.value = null;
                return false;
            }

            if (file_size > 1) {
                toast.error('Max File size Allowed 1Mb.');
                event.target.value = null;
                return false;
            }

            var file = event.target.files[0];
            var reader = new FileReader();
            reader.onload = function () {
                setInputs(inputs => ({ ...form_inputs, [event.target.name]: reader.result }));
            }
            reader.readAsDataURL(file);
        } else {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
        }
    }

    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <div className='row'>
                <div className="col-md-12">
                    <div className="card mb-4">
                        <h5 className="card-header">Cheque Format</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='row mb-3'>
                                    <div className='col-sm-6'>
                                        <div className='mb-3'>
                                            <label className="form-label text-capitalize">Select Bank *</label>
                                            <select name="bankId" value={form_inputs.bankId} onChange={handleInputChange} className="form-control">
                                                <option value="">Select Bank</option>
                                                {BankList && BankList.map((value) => {
                                                    return (
                                                        <option key={value.bankId} value={value.bankId}>{value.bankName}</option>
                                                    )
                                                })}
                                            </select>
                                            {simpleValidator.current.message('bank', form_inputs.bankId, 'required')}
                                        </div>
                                        <div className='mb-3'>
                                            <label className="form-label text-capitalize">Format Name *</label>
                                            <input name="formatName" value={form_inputs.formatName} onChange={handleInputChange} className="form-control" placeholder="Enter name" type="text" />
                                            {simpleValidator.current.message('format name', form_inputs.formatName, 'required')}
                                        </div>
                                    </div>
                                    <div className='col-sm-6'>
                                        <div className='mb-3'>
                                            <label className="form-label text-capitalize">Image <small className='ml-4'>Alludu file png, jpg and jpeg.</small></label>
                                            <input name="image" onChange={handleInputChange} className="form-control" type="file" accept="image/*" />
                                        </div>
                                        {form_inputs.image_url && <div className='mb-3 text-right'>
                                            <img src={form_inputs.image_url} alt='logo' width={100} />
                                        </div>}
                                    </div>
                                </div>

                                <div className='row mb-3'>
                                    <div className='col-sm-12 text-center'>
                                        <p className='mb-0'><b>Cheque Printing Configuration</b></p>
                                        <p><small>All Dimensions in mm only</small></p>
                                    </div>
                                    <div className='col-sm-6'>
                                        <p><b><u>Cheque Dimension</u></b></p>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Width of Cheque</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="chequeWidth" value={form_inputs.chequeWidth} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Height of Cheque</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="chequeHeight" value={form_inputs.chequeHeight} onChange={handleInputChange} className='form-control' placeholder='mm'/>
                                            </div>
                                        </div>

                                        <p><b><u>Cheque Date</u></b></p>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Starting Location from Top Edge</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="chequeDateStartingLocationFromTop" value={form_inputs.chequeDateStartingLocationFromTop} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Starting Location from Left Edge</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="chequeDateStartingLocationFromLeft" value={form_inputs.chequeDateStartingLocationFromLeft} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Style of Date</p>
                                            </div>
                                            <div className='col-3'>
                                                <select type='text' name='chequeDateStyleOfDate' value={form_inputs.chequeDateStyleOfDate} onChange={handleInputChange}  className='form-control' >
                                                    <option value="">Select Date</option>
                                                    <option value="dmY">d d m m y y y y</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Distance Between Characters</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="chequeDateDistanceBetweenCharacters" value={form_inputs.chequeDateDistanceBetweenCharacters} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>

                                        <p><b><u>Party's / Payee Name</u></b></p>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Starting Location from Top Edge</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="payeeNameStartingLocationFromTop" value={form_inputs.payeeNameStartingLocationFromTop} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Starting Location from Left Edge</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="payeeNameStartingLocationFromLeft" value={form_inputs.payeeNameStartingLocationFromLeft} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Width area</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="payeeNameWidth" value={form_inputs.payeeNameWidth} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-sm-6'>
                                        <p><b><u>Amount in Words</u></b></p>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Starting Location of 1st Line from Top Edge</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="amountWordsStartingLocation1LineFromTop" value={form_inputs.amountWordsStartingLocation1LineFromTop} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Starting Location of 1st Line from Left Edge</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="amountWordsStartingLocation1LineFromLeft" value={form_inputs.amountWordsStartingLocation1LineFromLeft} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Starting Location of 2nd Line from Top Edge</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="amountWordsStartingLocation2LineFromTop" value={form_inputs.amountWordsStartingLocation2LineFromTop} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Starting Location of 2nd Line from Left Edge</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="amountWordsStartingLocation2LineFromLeft" value={form_inputs.amountWordsStartingLocation2LineFromLeft} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Width area</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="amountWordsWidth" value={form_inputs.amountWordsWidth} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>

                                        <p><u><b>Amount in Figures</b></u></p>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Starting Location from Top Edge</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="amountFiguresStartingLocationFromLeft" value={form_inputs.amountFiguresStartingLocationFromLeft} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Starting Location from Left Edge</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="amountFiguresStartingLocationFromTop" value={form_inputs.amountFiguresStartingLocationFromTop} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-9'>
                                                <p className='mb-0'>Width area</p>
                                            </div>
                                            <div className='col-3'>
                                                <input type='text' name="amountFiguresWidth" value={form_inputs.amountFiguresWidth} onChange={handleInputChange} className='form-control' placeholder='mm' />
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className='text-center'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Save
                                    </button>
                                    <Link to="/admin/cheque-formates" className="btn btn-danger ms-3"> Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}

export default Setting;